/**
 * Optimizely experiment to control gradual rolling out of `/v2/menus` endpoint usage,
 * which provides single menu week per request (instead of all three active menus).
 */
export const EXPERIMENT_KEY_SINGLE_MENU_API = 'turnips_single_menu_api_v2'

/**
 * Optimizely experiment for Featured Range Merchandising and Browse refresh rollout.
 */
export const EXPERIMENT_KEY_FEATURED_RANGE_MERCHANDISING =
  'turnips_ofx_featured_range_merchandising'
